'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applyStyleModifiers;

var _modifiedStyles = require('./utils/modifiedStyles');

var _modifiedStyles2 = _interopRequireDefault(_modifiedStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Returns a function that evaluates a modifierConfig object against a component's props.
 * This function will return a string of CSS styles based on those inputs.
 * @param {Object} modifierConfig A modifierConfig object that defines the styles
 * @param {string} [modifierPropName=modifiers] The name of the prop that contains
 *                                              the modifiers array
 */
function applyStyleModifiers(modifierConfig) {
  var modifierPropName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'modifiers';

  return function (props) {
    var modifiers = props[modifierPropName],
        otherProps = _objectWithoutProperties(props, [modifierPropName]);

    return (0, _modifiedStyles2.default)(modifiers, modifierConfig, otherProps);
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/styled-components-modifiers/dist/applyStyleModifiers.js
// module id = 1467
// module chunks = 2